module.exports = {
  EDI_RFID_AUDIT_EXECUTION_DELETE_REQUEST: 'EDI_RFID_AUDIT_EXECUTION_DELETE_REQUEST',
  EDI_RFID_AUDIT_EXECUTION_DELETE_SUCCESS: 'EDI_RFID_AUDIT_EXECUTION_DELETE_SUCCESS',
  EDI_RFID_AUDIT_EXECUTION_DELETE_FAILURE: 'EDI_RFID_AUDIT_EXECUTION_DELETE_FAILURE',
};
